export default {
  scheduled_order: 'Pedido programado',
  show_more: 'Ver más',
  show_less: 'Ver menos',
  schedule_order: 'Programar pedido',
};
